import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const disableFeatureFlag = mutator({
  schema: z.object({ name: z.string() }),
  resolve: {},
  permissions: [
    {
      permission: "tenant:feature_flags_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { name } }) => {
    const [flag] = await tx.run(
      zql.featureFlags.where("name", name).where("tenantId", ctx.tenantId)
    );
    if (!flag) throw userFacingError("Feature flag not found");

    await tx.mutate.featureFlags.update({
      id: flag.id,
      enabledAt: null,
      updatedAt: Date.now(),
    });
  },
});
